import responsibleLuckyDrawBanner from '../../../assets/responsible-lucky-draw-banner.png';
import { LinkedText } from '../../../components/LinkedText';

const responsibleItems = [
  {
    icon: 'ri-time-line',
    title: 'Deposit Limits',
    desc: 'Set daily, weekly, or monthly deposit limits to keep your spending firmly in check. Adjustments require a mandatory cooling-off period to protect you.',
  },
  {
    icon: 'ri-pause-circle-line',
    title: 'Self-Exclusion',
    desc: 'Take a break whenever you need one. Our self-exclusion tool allows temporary or permanent account restrictions — no questions, no judgment.',
  },
  {
    icon: 'ri-information-line',
    title: 'Reality Checks',
    desc: 'Receive regular session reminders about time spent and money wagered to help you stay fully aware and in control of your gaming habits.',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: 'Support Resources',
    desc: 'Instant access to professional counselling organisations including national gambling helplines and mental health support services available 24/7.',
  },
];

export default function ResponsibleGamblingSection() {
  return (
    <section
      id="responsible-gambling-commitment"
      style={{ background: 'linear-gradient(135deg, #0d0101 0%, #180303 50%, #0d0101 100%)' }}
      className="py-24"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-14 items-start">
          {/* Image */}
          <div className="flex justify-center lg:justify-start">
            <div className="relative w-full max-w-sm md:max-w-2xl">
              <div className="absolute -inset-px rounded-2xl opacity-30"
                style={{ background: 'linear-gradient(135deg, #cc1100, #d4a017)' }} />
              <img
                src={responsibleLuckyDrawBanner}
                alt="MrCuci Deposit Lucky Draw promotion"
                className="relative w-full h-48 sm:h-56 md:h-72 lg:h-[24rem] object-cover object-center rounded-2xl"
              />
            </div>
          </div>

          {/* Text */}
          <div>
            <div className="inline-flex items-center gap-2 bg-[#cc1100]/15 border border-[#cc1100]/30 rounded-full px-4 py-1.5 mb-5">
              <span className="w-3 h-3 flex items-center justify-center">
                <i className="ri-heart-fill text-[#d4a017] text-xs" />
              </span>
              <span className="text-[#d4a017] text-xs font-semibold tracking-widest uppercase">Responsible Play</span>
            </div>
            <h2 className="text-3xl font-black text-white mb-4">
              Our Responsible Gambling{' '}
              <span
                className="text-transparent bg-clip-text"
                style={{ backgroundImage: 'linear-gradient(135deg, #cc1100, #d4a017)' }}
              >
                Commitment
              </span>
            </h2>
            <p className="text-gray-400 text-sm leading-relaxed mb-8">
              <LinkedText>
                At MrCuci, we genuinely believe gaming should be fun, entertaining, and safe — never harmful. We are deeply committed to promoting responsible gambling and empowering every player with the tools they need to stay in complete control of their experience.
              </LinkedText>
            </p>

            <div className="grid sm:grid-cols-2 gap-4 mb-8">
              {responsibleItems.map((item) => (
                <div
                  key={item.title}
                  className="rounded-xl p-4 border border-[#d4a017]/10 hover:border-[#d4a017]/30 transition-all duration-300"
                  style={{ background: 'linear-gradient(135deg, #1a0303, #220404)' }}
                >
                  <div className="w-8 h-8 flex items-center justify-center mb-3 rounded-lg"
                    style={{ background: 'linear-gradient(135deg, rgba(204,17,0,0.3), rgba(212,160,23,0.2))' }}>
                    <i className={`${item.icon} text-[#d4a017] text-lg`} />
                  </div>
                  <h3 className="text-white font-bold text-sm mb-1">{item.title}</h3>
                  <p className="text-gray-500 text-xs leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
